<mat-card>
  <mat-card-header class="nopadding">
    <span class="card-header-value">GENOME DATA</span>
  </mat-card-header>
  
  <mat-card-content>
    <p>Your genome is the complete set of your DNA, and it contains valuable information about your health, traits, and
        how your body may respond to certain medications. We generate several types of files during the sequencing
        process, each of which can be useful for different purposes:</p>

    <ul>
        <li>VCF (Variant Call Format): Contains details of the genetic variants identified in your genome.</li>
        <li>gVCF (Genomic VCF): Includes both variant and non-variant information, providing a more complete picture of
            your genome.</li>
        <li>BAM (Binary Alignment Map): A file showing how your DNA sequence aligns to the human reference genome, often
            used for re-analysis.</li>
        <li>FASTQ (Raw genome data): The original raw data produced by the sequencing machine. This is the most detailed
            format, but also the largest (~100Gb) and most complex to work with.</li>
    </ul>

    <h4>Why You Might Want Your Genome Data</h4>

    <p>You may wish to request your genome data for a variety of reasons, such as:</p>

    <ul>
        <li>Sharing with another healthcare provider or specialist for a second opinion.</li>
        <li>Using the data in independent research projects or with third-party analysis tools.</li>
        <li>Keeping a copy for your personal records or for future advances in genomics.</li>
    </ul>

    <p>Please note: These files can be very large and require specialist software to interpret. They are primarily
        intended for use by healthcare professionals, researchers, or genetic counselors.</p>

    <h4>How to Request Your Genome Data</h4>

    <p>For your security and privacy, we don’t provide direct download links. Instead, we will prepare your data on
        request and ensure it is shared with you in a secure and appropriate way.</p>

    <p>To request your genome data, please email us at <a href="mailto:contact@storegene.com">contact@storegene.com</a></p>

  </mat-card-content>
</mat-card>
